import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../store';
import { ListActionTarget } from '../../../models/ListActionTarget';
import { changeTarget, setTargetSelectionListId } from '../../store/addToCartOrList/actions';
import { Orderlist } from '../../../models/OrderList';
import { AppState } from '../../store/appState';

type UseTarget = {
    readonly target: ListActionTarget;
    readonly setTarget: (target: ListActionTarget) => void;
    readonly setTargetSelectionList: (list: Orderlist) => void;
};

export const useTarget = (): UseTarget => {
    const dispatch = useDispatch<AppDispatch>();

    const target = useSelector((state: AppState) => state.addToCartOrList.target);
    const setTarget = useCallback((newTarget: ListActionTarget) => dispatch(changeTarget(newTarget)), [dispatch]);
    const setTargetSelectionList = useCallback(
        (newSelectionList: Orderlist) => dispatch(setTargetSelectionListId(newSelectionList.id)),
        [dispatch]
    );

    return {
        target,
        setTarget,
        setTargetSelectionList
    };
};
